import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import Typography from '@material-ui/core/Typography';

const GettingPermissionsMessage = (props) => {

  const preferredLanguage = props.preferredLanguage
  const getTranslation = props.getTranslation || ((value) => value);
  return (
    <div>
      <Typography variant="h5">
        {getTranslation('We are working on getting your permissions set! This may take a few minutes.', preferredLanguage)}
      </Typography>
    </div>
  );
};
export default GettingPermissionsMessage;
